import { Layer } from 'const';
import * as Models from 'models';
import { getSafeLayer } from 'utils/layers';
import { isRegularRelation } from './relations/isRegularRelation';

export const prioritizeActiveLayerInLayeredRelation = <S extends Models.CombinedRelationStyles>(
  layeredRelation: Models.LayeredRegularRelationMap<S>,
  layer: Layer,
): Models.RegularRelationMap<S> => {
  return (layeredRelation)
    .update('styles', styles => styles.get(layer))
    .update('documentId', documentId => documentId.get(layer)) as unknown as Models.RegularRelationMap<S>;
};

export const prioritizeActiveLayerInLayeredRelations = (layeredRelations: Models.LayeredRelationsMap, layer: Layer): Models.RelationsMap => {
  return layeredRelations.map((layeredRelation) => {
    if (!isRegularRelation(layeredRelation)) {
      return layeredRelation;
    }

    const safeLayer = getSafeLayer(layeredRelation, layer);

    return prioritizeActiveLayerInLayeredRelation(layeredRelation, safeLayer);
  }) as Models.RelationsMap;
};

